import React, { useEffect } from 'react';
import { Chart, registerables } from 'chart.js';
import { orZero } from 'lib/utils/NumUtils';
import annotationPlugin from 'chartjs-plugin-annotation';
import CustomDoughnutController from './CustomDoughnutController';

const DoughnutGraph = (props) => {
    const chartEl = React.createRef();
    let chart = undefined;
    let data = props.data;
    let options = props.options;
    const percentageGoal = orZero(parseFloat(parseFloat(props.yesterday / props.target) * 100).toFixed(1));

    useEffect(() => {
        Chart.register(...registerables);
        Chart.register(annotationPlugin);
        Chart.register(CustomDoughnutController);

        if (data && chartEl.current && !chart) {
            const canvas = chartEl.current;
            const ctx = canvas.getContext('2d');
            if (!chart) {
                options.centertext = percentageGoal + '%';
                chart = new Chart(ctx, { type: 'CustomDoughnut', data: data, options: options });
            }
        }

        return () => {
            if (chart) {
                chart.destroy();
            }
        }

    }, [data]);

    return (
        <div className="graph-container doughnut-graph">
            { !props.mobile && props.title &&
                <div className="graph-header">
                    {props.title}
                </div>
            }
            <div className="graph-inner">
                <canvas id="chartjs-graph-doughnut" key={"chartjs-graph-doughnut"} width="100%" height="100%" ref={chartEl} />
            </div>
        </div>
    )
}

export default DoughnutGraph;